import { render, staticRenderFns } from "./KycKyb.vue?vue&type=template&id=5107e60e&scoped=true"
import script from "./KycKyb.vue?vue&type=script&lang=js"
export * from "./KycKyb.vue?vue&type=script&lang=js"
import style0 from "./KycKyb.vue?vue&type=style&index=0&id=5107e60e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5107e60e",
  null
  
)

export default component.exports